import { AppContext } from '@/contexts/AppContext/AppContextProvider';
import { Box, Group, Text } from '@mantine/core';
import { useContext } from 'react';

enum Rating {
	max_default_days = 'Рабочие места',
	max_parking_days = 'Парковка',
	rating = 'Рейтинг',
}

export const UserRating = () => {
	const { userRate } = useContext(AppContext);

	if (!userRate) return null;

	return (
		<Group justify="space-between" ta="center">
			<Box>
				<Text tt="uppercase" size="sm" c="dimmed" fw={700}>
					{Rating.rating}
				</Text>
				<Text fw={700} size="sm" lh={1.3}>
					{userRate?.rating}%
				</Text>
			</Box>

			<Box>
				<Text tt="uppercase" size="sm" c="dimmed" fw={700}>
					{Rating.max_default_days}
				</Text>
				<Text fw={700} size="sm" lh={1.3}>
					{userRate?.maxDefaultDays} дней
				</Text>
			</Box>

			<Box>
				<Text tt="uppercase" size="sm" c="dimmed" fw={700}>
					{Rating.max_parking_days}
				</Text>
				<Text fw={700} size="sm" lh={1.3}>
					{userRate?.maxParkingDays} дней
				</Text>
			</Box>
		</Group>
	);
};
